
import MessageBox from "../MessageBox.vue";
import {ref} from "@vue/runtime-core";
import {useRoute} from "vue-router";
import {computed, ComputedRef, watch} from "vue";
import CropperImageInput from "../../CropperImageInput.vue";
import {useStore} from "vuex";

export default {
  components: { CropperImageInput, MessageBox },
  props: {
    message: {
      required: true,
      type: String
    },
    animationIsReverse: {
      required: false,
      type: Boolean
    },
    user: {
      required: true,
      type: Object
    }
  },
  setup({ user }, { emit }) {
    const route = useRoute();
    const store = useStore();
    const newUser = user;
    const isTransitionFinished = ref(false);
    const isInputImageOpened: ComputedRef<boolean> = computed(
      () => store.getters["utils_module/isVisible"]
    );

    /** Reset animations everytime I leave a step. */
    watch(
      () => route.params.step,
      () => {
        if (
          Number(route.params.step) === 5 ||
          Number(route.params.step) === 7
        ) {
          isTransitionFinished.value = false;
        }
      }
    );

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    /** Loads a fallback image when an image rendering error occurs. */
    const loadFallbackImage = (event: Event) => {
      const img = event.target as HTMLImageElement;
      img.src = require("../../../../assets/static/icons/onerror-user.png");
    };

    const openInputImage = async (): Promise<void> => {
      await store.dispatch("utils_module/setVisibility", true);
    };

    const getCroppedImageUrl = (url: string) => {
      newUser.image = url;
      emit("update:user", newUser);
    };
    return {
      isTransitionFinished,
      isInputImageOpened,
      newUser,
      fluctuate,
      loadFallbackImage,
      openInputImage,
      getCroppedImageUrl
    };
  }
};
